import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import * as Popper from 'popper.js/dist/umd/popper';
import {MainHelper} from "../../models/main-helper";
import {SimpleMenu} from "../../models/simple-menu";


type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'simple-menu',
    templateUrl: './simple-menu.component.html',
    styleUrls: ['./simple-menu.component.css']
})
export class SimpleMenuComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService
                ){


        this.close = new EventEmitter<{id: string, code: string}>();
        this.initialise();
    }

    private initialise = (): void =>{
        this.helper = new MainHelper();
    };

    @Input() public menus: SimpleMenu[];
    @Input() private addRef: ElementRef | HTMLElement;
    @Input() private code: string;

    @Output()
    private readonly close: EventEmitter<{id: string, code: string}>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    private helper: MainHelper;
    private popper: Popper;
    private listenContextMenu: () => void;
    private listenMouseDown: () => void;

    ngOnInit(){
    }

    ngOnDestroy(){
        this.listenContextMenu();
        this.listenMouseDown();
    }

    ngAfterViewInit(){
        this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideMenu(e));
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideMenu(e));
        this.popperAdd();
    }

    //# hides menu
    private hideMenu = (e: MouseEvent): void =>{
        let hideMenu: boolean = true;

        let el = e.target;
        while (el){
            if (this.mainWrapper && this.mainWrapper.nativeElement.isSameNode(el)){
                hideMenu = false;
                break;
            }

            el = this.renderer.parentNode(el);
        }

        if (e && e.button === 2 && !hideMenu){
            e.preventDefault();
        }

        if (hideMenu){
            this.close.emit(null);
        }
    };

    //#emit result
    public emitResult = (disabled: boolean, id: string): void => {
        !disabled ? this.close.emit({id: id, code: this.code}): this.close.emit(null);
    }

    //# add popper for menu
    public popperAdd = (): void =>{
        this.helper.popperAdd(this.addRef, this.mainWrapper, document.body, 'right', ['right', 'left'], true);
        /*this.popper = new Popper(this.addRef.nativeElement, this.addPopper.nativeElement, {
            placement: 'left',
            modifiers: {
                flip: {
                    behavior: ['left', 'right']
                },
                preventOverflow: {
                    boundariesElement: document.body
                },
            },
            //onUpdate: () => console.log('work popper')
        });*/
        //this.popperAddVar.options.onUpdate = (data) => console.log(data)
    }

    //# update popper position
    public updatePopper = (): void =>{
        // this.helper.wait(() => this.popperAddVar.update(), 1000)
        this.popper.update()
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/simple-menu.component/simple-menu.component.ts